<template>
  <div class="facetfields" v-if="response && response.numFound && facets">
    <FacetField v-for="(facet, facetname) in ordered_facets" v-bind:facetname="facetname" v-bind:facet="facet" :key="facetname">
    </FacetField>
  </div>
</template>

<script>
//var _ = require('lodash');
import FacetField from './FacetField'

export default {
  name: 'facetfields',
  components: {
    FacetField
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    facets () {
      if (this.$store.state.response &&
          this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_fields) {
        return this.$store.state.response.facet_counts.facet_fields;

        //return _.orderBy(this.$store.state.response.facet_counts.facet_fields, 'asc');

      }
      return null;
    },
    ordered_facets() {
      var facetSort = [
          'Action_Status',
          'Framework_Programme',
          'Programme_Division',
          'Destination',
          'Mission',
          'Specific_Priorities',
          'Work_Programme_Title',
          'Call_Title',
          'Call_Identifier',
          'Action_Type',
          //  'Source',
          'Concepts',
          'Keywords',
          'Tags',
          'SME_Participation',
          'Focus_Area',
          'Eligible_Countries',
          ]

      if (this.$store.state.response &&
          this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_fields) {

          return Object.keys(this.$store.state.response.facet_counts.facet_fields).sort(
            function(x, y) {
              return facetSort.indexOf(x) - facetSort.indexOf(y)
            }
          ).reduce((r, k) => (r[k] =  this.$store.state.response.facet_counts.facet_fields[k], r), {});

      }
      return null;
    }
  }
}
</script>

<style scoped>
</style>
